import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const outputSubmissionUpload = async (data) =>
  api.post(API_URL + "output-submission", data);

export const getOutputSubmissionMentor = async (mentor_id) => {
  return api
    .get(API_URL + `output-submission/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getOutputSubmissionAdmin = async () => {
  return api
    .get(API_URL + `output-submission/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getOutputSubmission = async (ops_id) => {
  return api
    .get(API_URL + `output-submission/${ops_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmOutputSubmissionMentor = (output_id, confirm) => {
  return api
    .put(`${API_URL}output-submission/${output_id}/4/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmOutputSubmissionAdmin = (output_id, confirm) => {
  return api
    .put(`${API_URL}output-submission/${output_id}/5/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};
